import { NgModule } from '@angular/core';
import { DynamicScreenHeightDirective } from 'ng2-app/modules/directives/dynamic-screen-height/dynamic-screen-height.directive';

@NgModule({
  declarations: [
    DynamicScreenHeightDirective,
  ],
  exports: [
    DynamicScreenHeightDirective,
  ]
})
export class DynamicScreenHeightModule { }
